import React, { Fragment, useEffect } from 'react';
import { Label } from 'reactstrap';
import AsyncSelect from 'react-select/async';
import debounce from 'lodash/debounce';

const SelectOptionAsync = ({ promiseOptions, handleChange, selectedValue, placeholder, isMulti }) => {
    const debouncedPromiseOptions = debounce(promiseOptions, 300, { leading: false });

    useEffect(() => {
        return () => debouncedPromiseOptions.cancel(); // Bersihin debounce pas komponen di-unmount
    }, []);

    return (
        <Fragment>
                <AsyncSelect
                    cacheOptions
                    defaultOptions
                    isMulti={isMulti}
                    isClearable={true}
                    loadOptions={debouncedPromiseOptions} // Lebih clean
                    onChange={(selectedOption) => handleChange(selectedOption)}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    value={selectedValue}
                    placeholder={placeholder}
                />
        </Fragment>
    );
};

export default SelectOptionAsync;
